import { createContext, useContext, useEffect, useState } from "react";

import Lang from "./Lang.json"
import { LangContextProps, LangType } from "./LangType";
import { DropdownMenu } from "../components/Dropdown/Dropdown";
import { LanguagesIcon } from "lucide-react";



export type gWType = (value?: string, words?: ObjectType<string>) => string


const gW: gWType = (value?: string, words?: ObjectType<string>): string => {
    return "";
}

const LangContext = createContext<LangContextProps>({
    gW
});



export const LangProvider = ({ ...props }) => {


    const [lang, setLang] = useState<LangType>(true ? "ar" : navigator.language.split("-")[0] as LangType);
    // const [open,setOpen]=useState<boolean>(false);


    const languages: ObjectType<any>[] = [
        { code: "en", name: "English", icon: <></> },
        // {code:"tr",name:"Türkçe",icon:<></>},
        { code: "ar", name: "عربي", icon: <></> }
    ]


    useEffect(() => {
        const code = localStorage.getItem(process.env.REACT_APP_NAME + "-lang") as LangType;
        code && setLang(code)
    }, []);

    const setTheLang = (code: LangType) => {
        setLang(code);
        localStorage.setItem(process.env.REACT_APP_NAME + "-lang", code);
    }


    const LanguagesDrop = () => <div className=" relative z-[20]  "  >


        <DropdownMenu
            trigger={<div className=" flex gap-2 select-none  text-primary-800 duration-200  p-1 cursor-pointer    items-center rounded   " >
                <LanguagesIcon size={16} />  <p>{languages && languages.find(l => l?.code === lang)?.name}</p>
            </div>}

            items={languages.filter(l => l.code !== lang)?.map((lan, index) => ({
                label: lan.name,
                onClick: () => { setTheLang(lan.code) }
            }))}
        />



    </div>


    const gW = (value?: string, words?: ObjectType<string>): string => {

        value = (value || "").toLowerCase();

        // Get the Word Or sentence From the  Lang.json
        let sentence = (Lang as ObjectType<any>)?.[value]?.[lang] || value

        // if Get a Words Object
        if (words && typeof words === "object" && sentence as string) {


            Object.keys(words as ObjectType<string>).forEach(key => {
                sentence = sentence.replace(`[${key}]`, (Lang as ObjectType<any>)?.[words[key]]?.[lang] || words[key]);
            });

        }

        return sentence;
    }






    const values = {
        lang, setLang, gW, languages, LanguagesDrop
    }

    return (<LangContext.Provider value={values}>
        {props.children}
    </LangContext.Provider>);
}


export const useLangContext = () => useContext(LangContext);


